import React from 'react';
import { connect } from 'react-redux';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import { MdGroupAdd as GroupAddIcon, MdAdd as AddIcon } from 'react-icons/md';

import { getProperties, getReferrals, createReferralLink } from 'actions/tenantProfileActions';

import ReferralDialog from './ReferralDialog';
import ReferralList from './ReferralList';

import { AccentColor } from 'helpers/AccentColorHelper';

const Referrals = connect(
  store => ({
    propertyType: store.dashboard.propertyType,
    properties: store.tenantProfile.properties,
    referrals: store.tenantProfile.referrals,
    referralLinks: store.tenantProfile.referralLinks,
  }),
  dispatch => ({
    getProperties: () => dispatch(getProperties()),
    getReferrals: () => dispatch(getReferrals()),
    createReferralLink: id => dispatch(createReferralLink(id)),
  })
)(
  class Referrals extends React.Component {
    UNSAFE_componentWillMount() {
      this.setState({ referralDialogOpen: false });

      this.props.getProperties();
      this.props.getReferrals();
    }

    toggleReferralDialog = () => {
      this.setState({ referralDialogOpen: !this.state.referralDialogOpen });
    };

    render() {
      const style = {
        card: {
          color: '#424242 !important',
          fontFamily: '"Circular", sans-serif !important',
          height: '100%',
          overflow: 'auto',
        },
        card_header: {
          backgroundColor: '#fff',
          borderBottom: '1px solid #e0e0e0',
          padding: '11px 16px',
          fontFamily: 'Circular-Bold',
          backgroundImage: `-webkit-linear-gradient(left, ${AccentColor()}d6, ${AccentColor()}d6 49px, transparent 49px, transparent 100%)`,
          width: '100%',
        },
        card_text: {
          padding: '15px 8px 0 8px',
          fontFamily: '"Circular", sans-serif !important',
        },
      };

      if (this.props.propertyType === 'industrial' || this.props.propertyType === 'commercial') {
        return <React.Fragment />;
      }

      return (
        <div className="grid-column" style={{ height: '320px' }}>
          <Card style={style.card} className="card" initiallyExpanded={true}>
            <CardHeader
              id="card-header"
              style={style.card_header}
              title={
                <span>
                  <GroupAddIcon
                    size={18}
                    style={{ verticalAlign: 'middle', marginRight: '26px', color: 'white' }}
                  />
                  Referrals
                  <span>
                    <AddIcon
                      onClick={this.toggleReferralDialog}
                      style={{
                        fontSize: '22px',
                        cursor: 'pointer',
                        verticalAlign: 'middle',
                        float: 'right',
                      }}
                    />
                  </span>
                </span>
              }
            />
            <CardText style={style.card_text}>
              <ReferralList referrals={this.props.referrals} />
            </CardText>
          </Card>

          <ReferralDialog
            open={this.state.referralDialogOpen}
            toggleOpen={this.toggleReferralDialog}
            properties={this.props.properties}
            referralLinks={this.props.referralLinks}
            createReferralLink={this.props.createReferralLink}
          />
        </div>
      );
    }
  }
);

export default Referrals;
